module.exports = __webpack_public_path__ + "media/payment/discover-icon-30ded5f8.png";